import React, { useState, useEffect } from 'react';
import { FormProvider, useForm } from "react-hook-form"
import ReCAPTCHA from "react-google-recaptcha";
import PureModal from 'react-pure-modal';
import 'react-pure-modal/dist/react-pure-modal.min.css';
import CardInput from './CardInput';
import BookList from './BookList';
import UserForm from './UserForm';
import { get_next_subscription_date } from '../utils';
import { createTemporaryPaymentMethod, fetchTokenStatus, createUser } from '../api';
import moment from 'moment';
import { latestBook } from '../api/dummy';
import { BookComponent } from './Book';
import kennitala from './kennitala';

let timer = null
const SITE_KEY = '6LfcXFwpAAAAAM2lYwT4zmSV6of9jrtvRFVRTo2D'

const PurchaseForm = () => {
  const methods = useForm()
  const nextSubscriptionDate = get_next_subscription_date()
  const [show3DSecure, setShow3DSecure] = useState(false)
  const [iframe_url, setIframe_url] = useState('')
  const watchToken = methods.watch('token')
  const recaptchaRef = React.createRef();
  const [recaptchaToken, setRecaptchaToken] = useState('')
  const [recaptchaEnabled, setRecaptchaEnabled] = useState(false)
  const [shouldFinishPurchase, setShouldFinishPurchase] = useState(false)
  const [purchaseState, setPurchaseState] = useState('init')
  const [message, setMessage] = useState('')
  const watchBooks = methods.watch('books')
  const watchTotal = methods.watch('total_amount')
  const [show3DSecureError, setShow3DSecureError] = useState(false)
  const [disabled, setDisabled] = useState(false)

  let customer = {}
  let subscription = {}
  let payment_method = {}
  let additional_payment = {}

  useEffect(() => {
    if (shouldFinishPurchase && recaptchaToken) {
      finishPurchase()
    }
  }, [shouldFinishPurchase, recaptchaToken])


  const fetchingToken = () => {
    Promise.resolve(fetchTokenStatus(watchToken)).then(data => {
      if (data.status === "tokencreated") {
        clearInterval(timer)
        timer = null
        setShow3DSecure(false)
        setRecaptchaEnabled(true)
      }
      if (data.status === "failed") {
        clearInterval(timer)
        timer = null
        setShow3DSecureError(true)
      }
    })
  }

  // Watch token response from createTemporaryPaymentMethod
  useEffect(() => {
    if (watchToken && timer === null) {
      timer = setInterval(fetchingToken, 1000)
    }
  }, [watchToken])

  async function initRecaptcha(value) {
    const t = await recaptchaRef.current.executeAsync();
    setRecaptchaToken(t);
  }

  // Finish purchase
  const finishPurchase = () => {
    let data = methods.getValues()
    var firstName = data.name.split(' ').slice(0, -1).join(' ');
    var lastName = data.name.split(' ').slice(-1).join(' ');

    customer = {
      "first_name": firstName,
      "last_name": lastName,
      "email": data.email,
      "customer_reference": kennitala.clean(data.ssn),
      "address_1": data.address,
      "address_2": "",
      "address_3": "",
      "city": data.city,
      "zip_code": data.zip_code,
      "country": data.country_code
    }
    subscription = {
      "reference": kennitala.clean(data.ssn),
      "start_date": nextSubscriptionDate.format("YYYY-MM-DD"),
      "description": data.description,
    }
    payment_method = {
      token: methods.getValues('token')
    }

    if (moment().format('YYYY-MM-DD') === nextSubscriptionDate.format('YYYY-MM-DD')) {
      additional_payment = {
        "description": watchBooks.map(u => u.title).join(', '),
        "amount": data.total_amount,
        "currency": "ISK"
      }
    } else {
      additional_payment = {
        "description": 'ATH - Senda nýjustu bókina strax. Eldri bækur valdar: ' + watchBooks.map(u => u.title).join(', '),
        "amount": data.total_amount + 2750,
        "currency": "ISK"
      }
    }

    let userData = {
      customer,
      subscription,
      payment_method,
      additional_payment,
      recaptchaToken
    }

    createUser(userData).then(data => {
      if (data.status === 'success') {
        setPurchaseState('success')
      } else {
        setPurchaseState('error')
        setMessage(data.message)
      }
    })
  }



  const onSubmit = (data) => {
    setDisabled(true)
    let tempCardData = {
      "card_number": data.number,
      "expiration_year": data.exp_year,
      "expiration_month": data.exp_month,
      "cvv_number": data.cvc
    }
    createTemporaryPaymentMethod(tempCardData).then(returnData => {
      methods.setValue('token', returnData.token)
      setShow3DSecure(true)
      setIframe_url(returnData.card_verification_url)
    })
  };

  return (
    <>
      {purchaseState === 'init' &&
        <>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <h1 className="title mb-4">Komdu í Leynifélagið álfar og vampírur</h1>
                {recaptchaEnabled ?
                  <>
                    <p>Augnablik... erum að stofna áskriftina.</p>
                    <ReCAPTCHA asyncScriptOnLoad={initRecaptcha} onChange={() => setShouldFinishPurchase(true)} ref={recaptchaRef} size="invisible" sitekey={SITE_KEY} />
                  </>
                  :
                  <>
                    <p>Félagar í Leynifélaginu gerast áskrifendur að bókunum um Ísadóru Nótt og Mírabellu frænku hennar.
                      Áskrifendur fá bækurnar sendar heim - áður en þær birtast í verslunum.
                      Nýir áskrifendur fá Sumarþrautabók Ísadóru Nótt frítt með fyrstu sendingu.
                    </p>
                    <p>
                      <strong>Svona virkar þetta:</strong>
                    </p>
                    <div className="container">
                      <div className="row">
                        <div className="col-md-4 col-12">
                          <ul>
                            <li>Þrjár bækur á ári - í apríl, ágúst og nóvember. </li>
                            <li>Óvænt gjöf einu sinni á ári</li>
                            <li>Lægra verð! Hver bók kostar 2.750 fyrir áskrifendur. Fullt verð er 3.190 til 3.490 í verslunum.</li>
                            <li>Heimsending (í litríku umslagi) innifalin!</li>
                            <li>Sumarþrautabókin kemur FRÍTT með í byrjun áskriftar.</li>
                          </ul>
                        </div>
                        <div className="col-md-8 col-12">
                          <div className="book-container container mb-5">
                            <div className="row justify-content-end text-end">
                              <BookComponent check={false} key={latestBook.id} book={latestBook} />
                              <strong>Nýir áskrifendur fá nýjustu bókina,<br /> <em>{latestBook.title}</em>, með áskriftinni</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p className="fw-bold mb-5">Til að byrja í áskrift þarf aðeins að fylla út formið hér að neðan. </p>
                    <FormProvider {...methods}>
                      <form onSubmit={methods.handleSubmit(onSubmit)}>
                        <BookList />
                        <h2 className="sub-title mb-4">Næsta áskrift byrjar: {nextSubscriptionDate.format('D.M.YYYY')}</h2>
                        {watchBooks && watchBooks.length > 0 ?
                          <p>
                            Þú hefur valið að kaupa samtals {watchBooks.length} eldri bækur fyrir samtals {watchTotal} kr. sem verða skuldfærðar strax af kortinu ásamt nýjustu bókinni (2.750 kr.). Eftir það skuldfærum við kr. 2.750 þrisvar sinnum á ári, í apríl, ágúst og desember.
                          </p>
                          :
                          <p>Við kaupin munum við skuldfæra strax af kortinu fyrir nýjustu bókina (2.750 kr.) og eldri bækur ef þú hefur valið þær, eftir það er skuldfært þrisvar sinnum á ári þegar ný bók kemur út.</p>
                        }
                        <UserForm />
                        <CardInput />
                        <div className="text-end"><strong>Til skuldfærslu nú: {watchTotal + 2750} kr.</strong></div>
                        <div className="text-end">
                          <button className="buy-btn mt-5" type="submit" disabled={disabled}>
                            {disabled ? 'Augnablik...' : 'Kaupa'}
                          </button>
                        </div>
                        <div className="row justify-content-end">

                        <div className="text-end align-self-end col-6"><small>Athugið að við auðkenningu korts fer einungis fram auðkenning og því gæti upphæð birst sem 0 kr.</small></div>
                        </div>
                      </form>
                    </FormProvider>
                    <PureModal isOpen={show3DSecure} >
                      <div className='iframe-container'>
                        {show3DSecureError ?
                          <div className="text-center">
                            <h2 className="my-5">Villa!</h2>
                            <p>Villa kom upp við auðkenningu á korti.<br />Vinsamlegast reyndu aftur.</p>
                            <p><button className="btn btn-secondary mt-5" onClick={() => { methods.setValue('token', ''); setShow3DSecureError(false); setShow3DSecure(false) }}>Loka</button></p>
                          </div>
                          :
                          <iframe src={iframe_url} title="3dsecure" />
                        }
                      </div>
                    </PureModal>
                  </>
                }

              </div>
            </div>
          </div>
        </>
      }
      {
        purchaseState === 'success' &&
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <h1 className="title mb-4">Takk fyrir að kaupa áskrift</h1>
              <p>Nýjasta bókin ætti að berast í pósti á næstum dögum, ásamt öðrum eldri bókum ef þú valdir að kaupa þær. Næsta áskriftargreiðsla verður {nextSubscriptionDate.format('D.M.YYYY')}.</p>
            </div>
          </div>
        </div>
      }
      {
        purchaseState === 'error' &&
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <h1 className="title mb-4">Það kom upp villa!</h1>
              {message &&
                <p>{message}</p>
              }
              <p>Vinsamlegast reyndu aftur. Ef vandamálið leysist ekki innan tíðar getur þú haft samband við <a href="mailto:n29@n29.is">n29@n29.is</a></p>
            </div>
          </div>
        </div>
      }

    </>

  );
};

export default PurchaseForm;

// {
//   "customer": {
//       "first_name": "Jón",
//       "last_name": "Jónsson",
//       "email": "email@example.com",
//       "customer_reference": "0210892499",
//       "address_1": "Aðalstræti 1",
//       "address_2": "Íbúð 101",
//       "address_3": "Jón á bjöllu",
//       "city": "Reykjavík",
//       "zip_code": "101",
//       "country": "IS"
//   },
//   "subscription": {
//       "reference": "0210892499",
//       "plan": "1",
//       "start_date": "2025-12-02"
//   },
//   "payment_method": {
//       "token": "b5b56933ac4d872bb325ca302b8d50be7a3537de"
//   },
//   "additional_payment": {
//       "description": "[]",
//       "amount": "3990",
//       "currency": "ISK"
//   }
// }